import React from "react"
import styled from "styled-components"

import ArrowDown from "url:assets/images/icons/ArrowDown.svg"
import ArrowRight from "url:assets/images/icons/ArrowRight.svg"
import Exclamation from "url:assets/images/icons/Exclamation.svg"
import Back from "url:assets/images/icons/Back.svg"
import Cross from "url:assets/images/icons/Cross.svg"
import Locked from "url:assets/images/icons/Locked.svg"
import Menu from "url:assets/images/icons/Menu.svg"
import Shield from "url:assets/images/icons/Shield.svg"
import SmallArrow from "url:assets/images/icons/SmallArrow.svg"
import Cross2 from "url:assets/images/icons/Cross2.svg"
import QuestionMark from "url:assets/images/icons/question-mark.svg"
import ExternalLink from "url:assets/images/icons/ExternalLink.svg"
import IconTick from "url:assets/images/icons/Icon_Tick.svg"

import WhiteTick from "url:assets/images/icons/TickWhite.svg"

import ChevronDown from "url:assets/images/icons/chevron-down.svg"
import ChevronUp from "url:assets/images/icons/chevron-up.svg"
import ChevronLeft from "url:assets/images/icons/chevron-left.svg"
import ChevronRight from "url:assets/images/icons/chevron-right.svg"

const images = {
  ArrowDown,
  ArrowRight,
  Back,
  Cross,
  Exclamation,
  Locked,
  Menu,
  Shield,
  SmallArrow,
  Cross2,
  QuestionMark,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ExternalLink,
  IconTick,
  WhiteTick,
}

export enum IconType {
  ArrowDown,
  ArrowRight,
  Back,
  Cross,
  Exclamation,
  Locked,
  Menu,
  Shield,
  SmallArrow,
  Cross2,
  QuestionMark,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ExternalLink,
  IconTick,
  WhiteTick,
}

interface Props {
  type: IconType
  onClick?: () => void
}

export interface IconComponentProps {
  type: IconType
  onClick?: () => void
  active?: boolean
  fillDefault?: string
  fillHover?: string
  width?: number
  height?: number
}

const IconComponent = styled.div`
  display: inline-block;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  mask: url(${({ icon }) => icon}) no-repeat center / contain;
  -webkit-mask: url(${({ icon }) => icon}) no-repeat center / contain;
  background-color: ${({ fillDefault, active, fillHover }) => (active ? fillHover : fillDefault)};
  &:hover {
    background-color: ${({ fillHover }) => fillHover};
  }
`

export function IconStyleable({
  type,
  onClick,
  fillDefault,
  fillHover,
  width,
  height,
  active,
}: IconComponentProps) {
  const icon = IconType[type]
  return (
    <IconComponent
      onClick={onClick && onClick}
      active={active}
      icon={images[icon]}
      fillDefault={fillDefault}
      fillHover={fillHover}
      width={width}
      height={height}
    />
  )
}

export function Icon({ type, onClick }: Props) {
  const icon = IconType[type]
  return <img src={images[icon]} alt="icon" onClick={onClick} />
}
